const LOXO_POD_ROOT_HOST = 'app.loxo.co';

const isAllowedLoxoPodHost = (hostname: string): boolean => {
  const normalizedHostname = hostname.toLowerCase();
  return (
    normalizedHostname === LOXO_POD_ROOT_HOST ||
    /^[a-z0-9-]+\.app\.loxo\.co$/.test(normalizedHostname)
  );
};

const isAllowedDevLoopbackHost = (hostname: string): boolean => {
  if (!import.meta.env.DEV) {
    return false;
  }

  return hostname === 'localhost' || hostname === '127.0.0.1';
};

export const normalizeLoxoPodUrl = (podUrl: string): string => {
  const trimmedPodUrl = podUrl.trim();
  let url: URL;

  try {
    url = new URL(trimmedPodUrl);
  } catch {
    throw new Error('Invalid Loxo pod URL.');
  }

  const isLoxoPodHost = isAllowedLoxoPodHost(url.hostname);
  const isDevLoopbackHost = isAllowedDevLoopbackHost(url.hostname);

  if (
    url.username ||
    url.password ||
    url.pathname !== '/' ||
    url.search ||
    url.hash ||
    (!isLoxoPodHost && !isDevLoopbackHost) ||
    (isLoxoPodHost && (url.protocol !== 'https:' || url.port)) ||
    (isDevLoopbackHost && !['http:', 'https:'].includes(url.protocol))
  ) {
    throw new Error('Invalid Loxo pod URL.');
  }

  return url.origin;
};
